import React from 'react'
import Why_Choose_Us_card from './why_Choose_Us_card/Why_Choose_Us_card'
import Common_Title_1 from '../../common_components/common_title_1/Common_Title_1'

function Why_Choose_Us() {
    const cardsData = [
        {
            number: "01",
            title: "100% White-Label Platform",
            description: "Launch your own branded learning app instantly."
        },
        {
            number: "02",
            title: "Self-Paced, Interactive Courses",
            description: "Engage learners with self-paced interactive courses."
        },
        {
            number: "03",
            title: "Built for B2B Scalability",
            description: "We support multi-languages, control and bulk onboarding."
        },
        {
            number: "04",
            title: "Real-Time Tracking &amp; Certification",
            description: "Dashboard to track learner progress and course completion."
        }
    ];

    return (
        <>
            <section className='why_Choose_Us section_margin'>
                <div className="container">
                    <Common_Title_1
                        titleText={"Why Choose Us?"}
                        subText={"Where trust, quality, & growth come together."}
                    />
                    <div className="row">
                        {cardsData.map((card, index) => (
                            <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                                <Why_Choose_Us_card
                                    number={card.number}
                                    title={card.title}
                                    description={card.description}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default Why_Choose_Us
